import { render, staticRenderFns } from "./advisoryZjgwtjj.vue?vue&type=template&id=05b903af&scoped=true&"
import script from "./advisoryZjgwtjj.vue?vue&type=script&lang=js&"
export * from "./advisoryZjgwtjj.vue?vue&type=script&lang=js&"
import style0 from "./advisoryZjgwtjj.vue?vue&type=style&index=0&id=05b903af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b903af",
  null
  
)

export default component.exports